import { Component, ReactNode } from 'react';

interface Props {
  // Rendered in place of the children after a render throw — the call site
  // passes the legacy DependabilityCard so the admin still sees a card.
  fallback: ReactNode;
  children: ReactNode;
}

interface State {
  hasError: boolean;
}

// tenant-admin has no error boundary anywhere in src, so a render throw
// inside the dependability card used to unmount the ENTIRE WorkerV2 route
// (blank page). This boundary contains the blast radius to the card: the
// isDependabilityV2 payload validator catches the known partial-payload
// shapes, and this catches any future field drift the validator does not
// anticipate.
class DependabilityV2ErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  componentDidCatch(error: unknown) {
    // eslint-disable-next-line no-console
    console.warn(
      '[DependabilityV2] render failed; falling back to legacy card',
      error,
    );
  }

  render() {
    return this.state.hasError ? this.props.fallback : this.props.children;
  }
}

export default DependabilityV2ErrorBoundary;
